var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-big"},[_c('div',{staticClass:"home"},[_c('el-container',{staticStyle:{"height":"100%"}},[_c('el-header',[_c('s-header')],1),_vm._v(" "),_c('el-container',{staticClass:"show-el-container"},[_c('left-menu'),_vm._v(" "),_c('el-main',[_c('router-view')],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9437f83e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/index.vue
// module id = LzkH
// module chunks = 81